module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Foreword"
    }
  }, [_c('h2', {
    staticClass: "fmt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#toc1",
      "id": "rtoc1"
    }
  }, [_c('span', {
    staticClass: "cb"
  }, [_vm._v("Foreword")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The public need for transportation such as that provided by Amtrak is a given, and by learning and respecting the past, we can only strengthen future outcomes in meeting that need. Policy is a leading and key ingredient for moving public transportation forward and for formulating ongoing policy. Up to the creation of Amtrak, government’s policy was to allow the free market to provide for passenger transportation by road, rail, and air. This changed with the collapsing rail network in the Northeast in the 1960s, forcing a shift in thinking about government’s role.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The debate about Amtrak continues: Is public funding justified? Money is not about how much is spent but how wisely it is spent. Proving the wisdom of expenditure can be very challenging for an organization that exists more in a state of flux than in one of stability and is influenced by political opinion and erratic financial support. One must always recognize the realities of the transportation business—safety cannot be bought. Human and material assets require ongoing maintenance and eventual renewal, and both are immune to, and cannot be invalidated by, the influences that have always affected Amtrak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_parab"
  }, [_vm._v("Organization and culture are derived and formulated from what leadership experiences, so as you read this book you can draw your own conclusions about the presence or absence of value in an environment of ongoing change. Raw truths without self-serving agendas are expressed throughout. The authors have done an excellent job of describing and evaluating the reality of Amtrak’s 50-year life—something I conclude should be called “lessons learned.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Ronald L. Batory,")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Administrator for the Federal Railroad Administration, retired.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eabcd06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Foreword.vue
// module id = 84
// module chunks = 0